export const withHttpsProtocol = (value: string) => {
  const trimmedValue = value.trim().replace(/^(?:https?:\/\/)+(?=https?:\/\/)/i, '');

  if (!trimmedValue || /^https?:\/\//i.test(trimmedValue)) {
    return trimmedValue;
  }

  return `https://${trimmedValue}`;
};
